<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1" v-model="filterFormModel.keyword" v-on:keydown.enter="search"
                          :placeholder="$t('keyword')"></b-form-input>
            <form-select class="mr-1" :model="filterFormModel" attribute="status" :options="[
                  {value: null, text: $t('all')},
                  {value: '0', text: $t('activated')},
                  {value: '1', text: $t('deactivated')},
                ]"></form-select>
            <button @click="search" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-sorting" v-if="['owner', 'admin', 'tech', 'agency'].includes($store.state.user.role)">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-2">{{ $t('ext') }}</div>
            <div class="col-lg-4">{{ $t('userInfo') }}</div>
            <div class="col-lg-2">{{ $t('phone') }}</div>
            <div class="col-lg-2">{{ $t('status') }}</div>
            <div class="col-lg-2"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-2">
              <b class="c-smart-table__label">{{ $t('ext') }}: </b>
              <span>{{ item.ext }}</span>
              <p><label class="badge badge-info">{{ item.role }}</label></p>
              <p v-if="['owner', 'admin', 'tech'].includes($store.state.user.role)">
                <a href="javascript:;" @click="use(item._id, 'callio')" type="button-link">
                  <i class="fa fa-angle-double-right"></i>Callio&nbsp;
                </a>
                <font-awesome-icon cursor="pointer" icon="copy" color="#17a2b8" @click="copyLink(item._id)"/>
              </p>
              <!-- Khách thuộc domain đối tác → thêm link đăng nhập vào domain đó (cùng token, cùng quyền) -->
              <p v-if="partnerUseUrl && ['owner', 'admin', 'tech'].includes($store.state.user.role)">
                <a href="javascript:;" @click="use(item._id, 'callio', partnerUseUrl)" type="button-link"
                   :title="partnerUseUrl">
                  <i class="fa fa-angle-double-right"></i>{{ partnerBrandLabel }}&nbsp;
                </a>
                <font-awesome-icon cursor="pointer" icon="copy" color="#6c5ce7"
                                   @click="copyLink(item._id, partnerUseUrl)"/>
              </p>
            </div>
            <div class="col-lg-4">
              <div><b>{{ $t('name') }}: </b><span>{{ item.name }}</span></div>
              <div><b>{{ $t('email') }}: </b><span>{{ mustHidden(item) ? hideEmail(item) : item.email }}</span></div>
              <div><b>{{ $t('group') }}: </b><span>{{ item.group ? item.group.name : $t('default') }}</span></div>
              <div><b>{{ $t('ccuNumberLimit') }}: </b><span>{{ item.ccuNumberLimit }}</span></div>
              <div v-if='item.lastToken && item.lastToken.lastRequestTime'>
                <b>{{ $t('lastRequestTime') }}: </b>
                <span>{{ item.lastToken.lastRequestTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </div>
              <div v-if="item.pwdTime && item.pwdTime > 0">
                <label class="badge badge-danger">{{ $t('pwdLockLabel') }}
                  {{ item.pwdTime | moment('DD/MM/YYYY HH:mm:ss') }}</label>
              </div>
            </div>
            <div class="col-lg-2">
              <b class="c-smart-table__label">{{ $t('phone') }}: </b>
              <span>{{ mustHidden(item) ? hidePhone(item) : item.phone }}</span>
              <span v-if="!item.phone">{{ $t('notUpdated') }}</span>
            </div>
            <div class="col-lg-2">
              <p>
                <label v-if="item.active" class="badge badge-success">{{ $t('activated') }}</label>
                <label v-if="!item.active" class="badge badge-danger">{{ $t('deactivated') }}</label>
              </p>
            </div>
            <div class="col-lg-2">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col">
                    <button @click="update(item._id)" type="button"
                            v-if="['owner', 'admin', 'tech', 'agency'].includes($store.state.user.role)"
                            class="btn btn-sm btn-info mr-1">
                      <font-awesome-icon icon="edit"/>&nbsp;{{ $t('edit') }}
                    </button>
                    <button @click="changeStatus(item._id, 'deactivate')" type="button"
                            v-if="['owner', 'admin', 'tech', 'agency', 'account'].includes($store.state.user.role) && item.active"
                            class="btn btn-sm btn-danger mr-1" :disabled="saveLoading">
                      <font-awesome-icon icon="ban" v-if="!saveLoading"/>
                      <b-spinner v-else small></b-spinner>
                      &nbsp;{{ $t('deactivate') }}
                    </button>
                    <button @click="changeStatus(item._id, 'activate')" type="button"
                            v-if="['owner', 'admin', 'tech', 'agency'].includes($store.state.user.role) && !item.active"
                            class="btn btn-sm btn-success mr-1" :disabled="saveLoading">
                      <font-awesome-icon icon="key" v-if="!saveLoading"/>
                      <b-spinner v-else small></b-spinner>
                      {{ $t('activate') }}
                    </button>
                    <button @click="unlock(item._id)" type="button"
                            v-if="['owner', 'admin'].includes($store.state.user.role) && item.pwdTime && item.pwdTime > 0"
                            class="btn btn-sm btn-success mr-1" :disabled="saveLoading">
                      <font-awesome-icon icon="key" v-if="!saveLoading"/>
                      <b-spinner v-else small></b-spinner>
                      {{ $t('unlock') }}
                    </button>
                    <button @click="showFormReset(item._id)" type="button" class="btn btn-sm btn-warning mb-2"
                            v-if="['owner', 'admin', 'tech', 'agency'].includes($store.state.user.role)">
                      <font-awesome-icon icon="sync-alt"/>&nbsp;{{ $t('resetPassword') }}
                    </button>
                    <client-user-move :item="item" :client="client" class="mr-1"
                                      v-if="['owner', 'admin', 'tech'].includes($store.state.user.role)"></client-user-move>
                    <client-user-device :user="item"></client-user-device>
                    <button @click="copy(`https://client.callio.vn/register/${$store.state.user._id}?ref=${item._id}`)"
                            type="button" class="btn btn-sm btn-info mr-1">
                      <i class="fa fa-share"></i>
                      Link giới thiệu
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal size="lg" v-model="showForm" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
      <div class="row">
        <div class="col-md">
          <form-input :label="$t('name')" :model="formModel" attribute="name" :errors="formErrors">
          </form-input>
          <form-input :label="$t('email')" :model="formModel" attribute="email" :errors="formErrors"
                      type="email"></form-input>
          <form-input v-if="!formModel._id" :label="$t('password')" :model="formModel" attribute="password"
                      :errors="formErrors" type="password"></form-input>
          <form-input :label="$t('phone')" :model="formModel" attribute="phone" :errors="formErrors">
          </form-input>
          <form-textarea :label="$t('desc')" :model="formModel" attribute="desc" :errors="formErrors">
          </form-textarea>
        </div>
        <div class="col-md">
          <client-user-group-select :label="$t('group')" :model="formModel" :errors="formErrors">
          </client-user-group-select>
          <form-select :label="$t('role')" :model="formModel" attribute="role" :errors="formErrors"
                       :options="roles"></form-select>
          <div class="row">
            <div class="col-md">
              <form-input :label="$t('ext')" :model="formModel" attribute="ext" :errors="formErrors"></form-input>
            </div>
            <div class="col-md">
              <form-input :label="$t('extPassword')" :model="formModel" attribute="extPassword"
                          :errors="formErrors"></form-input>
            </div>
          </div>
          <form-input :disabled="$store.state.user.role !== 'owner'" :label="$t('ccuNumberLimit')" :model="formModel" attribute="ccuNumberLimit" :errors="formErrors"></form-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <form-checkbox :chk-label="$t('activated')" :model="formModel" attribute="active"
                         :errors="formErrors"></form-checkbox>
        </div>
      </div>
    </b-modal>
    <b-modal v-model="showResetPasswordForm" :title="$t('resetPassword')" @ok="resetPassword" no-close-on-backdrop
             no-enforce-focus>
      <form-input :model="resetPasswordModel" attribute="password"></form-input>
    </b-modal>
  </div>
</template>

<script>
import List from '../../mixins/List';
import CRUD from "../../mixins/CRUD";
import ClientUserGroupSelect from "../../components/ClientUserGroupSelect";
import ClientUserMove from './ClientUserMove';
import ClientUserDevice from "./ClientUserDevice";

export default {
  components: {
    ClientUserDevice,
    ClientUserGroupSelect, ClientUserMove
  },
  props: ['client'],
  mixins: [List, CRUD],
  data() {
    return {
      showList: false,
      saveLoading: false,
      service: 'client-user',
      autoLoad: true,
      defaultFormModel: {
        client: this.client._id,
        extNumber: 10000,
        role: 'agent',
        active: true,
        ccuNumberLimit: 1
      },
      defaultFilterFormModel: {
        status: '0',
        client: this.client._id,
      },
      roles: [
        {value: 'owner', text: this.$t('owner')},
        {value: 'supervisor', text: this.$t('supervisor')},
        {value: 'agent', text: this.$t('agent')},
      ],
      showResetPasswordForm: false,
      resetPasswordModel: {}
    }
  },
  i18n: {
    messages: {
      en: {
        group: "Group",
        clientUser: 'Users',
        title: 'Client users list',
        ext: 'Extension number',
        extPassword: 'Extension password',
        resetPassword: 'Reset password',
        resetConfirm: 'Are you sure to reset password?',
        resetSuccess: 'Password has been reset successfully!',
        resetFailed: 'Reset password failed, please try again!',
        extPlaceholder: '5 or 6 digits, not begin by 0',
        default: 'Default',
        lastRequestTime: 'Last login time',
        login: 'Login',
        forwardToPhoneIf: 'Forward calls to user\'s phone when',
        timeout: 'Timeout',
        offline: 'User is offline',
        busy: 'User is busy',
        notUpdated: 'Not updated',
        deactivate: 'Deactivate',
        deactivateConfirm: 'Are you sure to deactivate this user?',
        deactivateSuccess: 'Deactivate successfully!',
        deactivateFailed: 'Deactivate failed!',
        activateConfirm: 'Are you sure to activate this user?',
        activateSuccess: 'Activate successfully!',
        activateFailed: 'Activate failed!',
        pwdLockLabel: "Temporarily lock login from",
        unlock: "Unlock",
        copyFailed: "Copy failed",
        copied: "Copied",
        ccuNumberLimit: "Giới hạn cuộc gọi đồng thời"
      },
      vi: {
        group: "Nhóm",
        clientUser: 'Tài khoản',
        title: 'Danh sách tài khoản của khách',
        ext: 'Số nhánh',
        extPassword: 'Mật khẩu nhánh',
        resetPassword: 'Reset mật khẩu',
        resetConfirm: 'Bạn chắc chắn muốn reset mật khẩu không?',
        resetSuccess: 'Reset mật khẩu thành công!',
        resetFailed: 'Reset mật khẩu thất bại, mời bạn thử lại sau!',
        extPlaceholder: '5 hoặc 6 số, không bắt đầu bằng 0',
        default: 'Mặc định',
        lastRequestTime: "Đăng nhập lần cuối",
        login: 'Đăng nhập',
        forwardToPhoneIf: 'Chuyển tiếp cuộc gọi đến điện thoại của người dùng khi',
        timeout: 'Hết thời gian chờ',
        offline: 'Người dùng offline',
        busy: 'Người dùng bận',
        notUpdated: 'Chưa cập nhật',
        deactivate: 'Khoá',
        deactivateConfirm: 'Bạn có chắc muốn khoá tài khoản này?',
        deactivateSuccess: 'Khoá tài khoản người dùng thành công',
        deactivateFailed: 'Khoá tài khoản người dùng thất bại',
        activateConfirm: 'Bạn có chắc muốn kích hoạt lại tài khoản người dùng này',
        activateSuccess: 'Kích hoạt thành công',
        activateFailed: 'Kích hoạt thất bại',
        pwdLockLabel: "Tạm khoá đăng nhập từ",
        unlock: "Mở khoá",
        copyFailed: "Sao chép thất bại",
        copied: "Sao chép thành công",
        ccuNumberLimit: "Giới hạn cuộc gọi đồng thời"
      }
    }
  },
  computed: {
    // Khách thuộc domain đối tác: partnerDomain populate {name, domain} (client.js populate select 'name domain')
    partnerUseUrl() {
      const pd = this.client && this.client.partnerDomain;
      return (pd && typeof pd === 'object' && pd.domain) ? `https://${pd.domain}` : null;
    },
    partnerBrandLabel() {
      const pd = this.client && this.client.partnerDomain;
      return (pd && typeof pd === 'object') ? (pd.name || pd.domain || '') : '';
    }
  },
  methods: {
    copy(str) {
      this.$copyText(str).then(() => {
        this.$swal({
          text: this.$t('copied', ['link']),
          icon: 'success',
          toast: true,
          position: 'top-end',
          timer: 5000,
        });
      }, () => {
        this.$swal({
          title: this.$t('error'),
          text: this.$t('copyFailed'),
          icon: 'error'
        });
      })
    },
    showFormReset(id) {
      this.resetPasswordModel.id = id;
      this.showResetPasswordForm = true;
    },
    resetPassword: function () {
      let loader = this.$loading.show();
      this.$service.put(this.service + '/' + this.resetPasswordModel.id + '/password', this.resetPasswordModel).then(response => {
        if (response.data) {
          this.load();
          this.$swal({
            title: this.$t('success'),
            text: this.$t('resetSuccess'),
            icon: 'success'
          });
        } else {
          this.$swal({
            title: this.$t('error'),
            text: this.$t('resetFailed'),
            icon: 'error'
          });
        }
      }).finally(() => {
        loader.hide();
      });
    },
    list() {
      this.load();
      this.showList = true;
    },
    search() {
      this.filterFormModel.page = 1;
      this.load();
    },
    changeStatus(id, action) {
      this.$swal({
        icon: 'warning',
        text: action === 'deactivate' ? this.$t('deactivateConfirm') : this.$t('activateConfirm')
      }).then(result => {
        if (result.value) {
          this.saveLoading = true;
          this.$service.post(`/client-user/${action}/${id}`, {client: this.client._id}).then(response => {
            if (response && response.data) {
              this.$swal({
                icon: 'success',
                text: action === 'deactivate' ? this.$t('deactivateSuccess') : this.$t('activateSuccess'),
                toast: true,
                position: 'top-end',
                timer: 5000,
              })
            } else {
              this.$swal({
                icon: 'error',
                text: action === 'deactivate' ? this.$t('deactivateFailed') : this.$t('activateFailed'),
              })
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
              this.showForm = false;
            }
          }).finally(() => {
            this.load();
            this.saveLoading = false;
          })
        }
      })
    },
    use: function (id, app, baseUrl) {
      let loader = this.$loading.show();
      let url;
      if (app === 'callio') {
        url = process.env.VUE_APP_CLIENT_URL + "/use/";
      }
      if (app === 'ttdh') {
        url = process.env.VUE_APP_CLIENT_URL_2 + "/use/";
      }
      // baseUrl override (vd domain đối tác) — token host-agnostic nên dùng chung
      if (baseUrl) {
        url = baseUrl + "/use/";
      }
      this.$service.get(this.service + "/token/" + id, {}).then(response => {
        this.load();
        window.open(url + response.data.token, '_blank');
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
        }
      }).finally(() => {
        loader.hide();
      });
    },
    reset: function () {
      this.filterFormModel = {};
      Object.assign(this.filterFormModel, this.defaultFilterFormModel);
      this.load();
    },
    unlock(id) {
      this.$swal({
        icon: 'warning',
        text: this.$t('activateConfirm'),
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          this.saveLoading = true;
          this.$service.post(`/client-user/unlock/${id}`, {client: this.client._id}).then(response => {
            if (response && response.data) {
              this.$swal({
                icon: 'success',
                text: this.$t('activateSuccess'),
                toast: true,
                position: 'top-end',
                timer: 5000,
              })
            } else {
              this.$swal({
                icon: 'error',
                text: this.$t('activateFailed'),
              })
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
              this.showForm = false;
            }
          }).finally(() => {
            this.load();
            this.saveLoading = false;
          })
        }
      })
    },
    mustHidden(item) {
      let hidden = false;
      if (['sales', 'kpiSales'].includes(this.$store.state.user.role) && (!item.sales || item.sales._id !== this.$store.state.user._id)) {
        hidden = true;
      }
      // if (this.$store.state.user.role === 'am' && (!item.account || item.account._id !== this.$store.state.user._id)) {
      //   hidden = true;
      // }
      if (['marketing'].includes(this.$store.state.user.role)) {
        hidden = true;
      }
      return hidden;
    },
    hidePhone: function (item) {
      if (item.phone) {
        return item.phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{4})(\d{3})/, '$1xxxx$3');
      }
    },
    hideEmail: function (item) {
      if (item.email) {
        return item.email.replace(/(.{2})(.*)(?=@)/,
            function (gp1, gp2, gp3) {
              for (let i = 0; i < gp3.length; i++) {
                gp2 += "*";
              }
              return gp2;
            });
      }
    },
    copyLink(id, baseUrl) {
      this.$service.get(`/client-user/token/${id}`, {})
          .then(response => {
            let base = baseUrl || process.env.VUE_APP_CLIENT_URL;
            let link = `${base}/use/${response.data.token}`;
            this.copy(link);
          })
          .catch(error => {
            this.$swal({
              text: error.response.data.message,
              icon: 'error'
            });
          });
    }
  },
  mounted() {
    this.$bus.$on(`client${this.client._id}UserLoad`, this.load)
  },
  beforeDestroy() {
    this.$bus.$off(`client${this.client._id}UserLoad`)
  }
}
</script>
